import auth from "./auth";
import * as api from "./openapi-generator";
import { useAuthenticationStore } from "@/stores/authentication";

export interface Client {
  //packages: api.PackagesApi;
  downloads: api.DownloadsApi;
  search: api.SearchApi;
  audit:api.AuditApi;
  agency:api.AgencyApi;
  packages: api.PackagesApi;
}

function getPath(): string {
  const base = "/api";
  const location = window.location;
  const path =
    location.protocol +
    "//" +
    location.hostname +
    (location.port ? ":" + location.port : "") +
    base +
    (location.search ? location.search : "");

  return path.replace(/\/$/, "");
}

function createClient(): Client {
  const path = import.meta.env.VITE_SERVER_HOST;
  const config: api.Configuration = new api.Configuration({
    basePath: path,
    accessToken: () =>
      auth.getUser().then((user) => (user ? user.access_token : "")),
    middleware: [
      {
        post(context) {
          if (context.response.status == 401) {
            useAuthenticationStore().removeUser();
            return Promise.resolve();
          }
          return Promise.resolve(context.response);
        },
      },
    ],
  });
  console.log("SDPS client created", path);

  return {
    //packages: new api.PackagesApi(config),
    downloads: new api.DownloadsApi(config),
    search: new api.SearchApi(config),
    audit: new api.AuditApi(config),
    agency: new api.AgencyApi(config),
    packages: new api.PackagesApi(config),
  };
}

function storageServiceDownloadURL(aipId: string): string {
  return (
    getPath() +
    `/storage/{aip_id}/download`.replace(
      `{${"aip_id"}}`,
      encodeURIComponent(aipId)
    )
  );
}

const client = createClient();

export { api, client, storageServiceDownloadURL };
